import React, { useState, useEffect } from "react";

// material import
import {
  Autocomplete,
  Box,
  Card,
  Chip,
  CircularProgress,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";

// project import
import CustomTable from "../../ui-components/customTable";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PopUpModal from "../../ui-components/PopUpModal";
import AdminDBServices from "../../services/v1/adminDBServices";
import { useSnackbar } from "../../ui-components/snackbarProvider";
import ActiveDonor from "./activeDonor";

const InActiveDonors = ({
  inActiveDonors,
  fetchAllDonations,
  fetchAllInactiveDonors,
}) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [type, setType] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [packageFilter, setPackageFilter] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const { showSnackbar } = useSnackbar();

  const columns = [
    { label: "No", field: "reservationNumber" },
    {
      label: "Donor Name",
      field: "donorName",
      renderCell: (row) => `${row.title} ${row.donorName}`,
    },
    { label: "Contact No", field: "contactNo" },
    { label: "WhatsApp No", field: "whatsappNo", align: "center" },
    { label: "Booking Date", field: "reservedDate", align: "center" },
    { label: "Type", field: "type" },
    // {
    //   label: "Payment",
    //   field: "paymentType",
    //   renderCell: (row) => (
    //     <Chip
    //       label={row.paymentType}
    //       color={row.paymentType === "Success" ? "success" : "warning"}
    //       variant="contained"
    //       size="small"
    //     />
    //   ),
    // },
    { label: "Package", field: "package" },
    {
      field: "moreInfo",
      align: "center",
      renderCell: (row) => (
        <Box display="flex" alignItems="center" gap={3}>
          <VisibilityIcon
            text="View Donor Details"
            color="secondary"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setIsModalOpen(true);
            }}
          />
        </Box>
      ),
    },
  ];

  // Filter the rows dynamically based on selected filters
  const filteredRows = inActiveDonors.sort((a, b) => {
    const da = a.reservedDate || '';
    const db = b.reservedDate || '';
    // reservedDate is in YYYY-MM-DD format so string compare works
    return da.localeCompare(db);
  });

  return (
    <Box>
      <Box>
        {inActiveDonors.length > 0 ? (
          <CustomTable columns={columns} rows={filteredRows} />
        ) : (
          <Typography variant="body1" color="error">
            There are no Inactive donors Available!
          </Typography>
        )}
      </Box>
      <Box>
        <PopUpModal
          open={isModalOpen}
          handleCloseDialog={() => setIsModalOpen(false)}
          title="Donor Details"
          content={
            <ActiveDonor
              fetchAllDonations={fetchAllDonations}
              fetchAllInactiveDonors={fetchAllInactiveDonors}
              selectedRow={selectedRow}
              handleCloseDialog={() => setIsModalOpen(false)}
            />
          }
          maxWidth={700}
          showCloseIcon={true}
        />
      </Box>
    </Box>
  );
};

export default InActiveDonors;
